import { Field, Tooltip } from "@EMOrg-prd/react-standard";
import { useCallback, useState } from "react";

interface Props {
  value: string;
  placeholder?: string;
  label?: string;
}

const PLACEHOLDER_VALUES = [
  'Enter client id and scope then click on "Request token" your token will appear here',
  "Requesting token...",
];

const CodeBox = ({ value, placeholder, label }: Props) => {
  const [copied, setCopied] = useState(false);

  const isTokenReady =
    !!value && !PLACEHOLDER_VALUES.includes(value);

  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(value);

    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  }, [value]);

  return (
    <Tooltip variant="below" style={{ width: "100%" }}>
      <Tooltip.Passage>
        {label && <Field.Label>{label}</Field.Label>}
        <pre
          onClick={() => {
            if (isTokenReady) handleClick();
          }}
          style={label ? { marginTop: 0 } : {}}
        >
          {isTokenReady ? (
            "Token is ready. Click here to copy to clipboard"
          ) : value ? (
            value
          ) : (
            <span style={{ opacity: 0.5 }}>{placeholder}</span>
          )}
        </pre>
      </Tooltip.Passage>
      {isTokenReady && (
        <Tooltip.Content>
          {copied ? "Copied!" : "Click to copy to clipboard"}
        </Tooltip.Content>
      )}
    </Tooltip>
  );
};

export default CodeBox;
